import { periodFormat } from 'utils/common';

export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      eventName: filter.eventName[0] ? filter.eventName : '*',
      datePeriod: periodFormat(filter.datePeriod),
      member: filter.search ? filter.search : '*',
      addressCountry: filter.addressCountry[0] ? filter.addressCountry : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
